// src/routes/index.tsx
import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import Dashboard from "../components/Dashboard";
import Analytics from "../components/Analytics";
import AnalyticsMap from "../components/AnalyticsMap";
import Login from '../Login';
import LoginCallback from '../LoginCallback';
import NotAuthorized from '../NotAuthorized';

// Simple auth check function - updated to work with Zitadel
const isAuthenticated = () => {
  const idTokenKey = `oidc.user:${process.env.REACT_APP_ZITADEL_AUTHORITY}:${process.env.REACT_APP_ZITADEL_CLIENT_ID}`;
  const idToken = window.localStorage.getItem(idTokenKey);
  
  if (idToken) {
    try {
      const parsed = JSON.parse(idToken);
      const profile = parsed.profile || {};
      const roles = profile['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      return roles && roles.includes('BtAddressApp');
    } catch (error) {
      console.error('Error parsing user info:', error);
      return false;
    }
  }
  return false;
};

// Protected route wrapper
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/not-authorized" replace />;
  }
  return <>{children}</>;
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/login/callback",
        element: <LoginCallback />,
      },
      {
        path: "/not-authorized",
        element: <NotAuthorized />,
      },
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/analytics",
        element: (
          <ProtectedRoute>
            <Analytics />
          </ProtectedRoute>
        ),
      },
      {
        path: "/analytics-map",
        element: (
          <ProtectedRoute>
            <AnalyticsMap />
          </ProtectedRoute>
        ),
      }
    ],
  },
]);
